import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge, usePoll, fmtUSDT, fmtINR } from "@/components/common";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  usePoll(() => api.get("/customer/orders").then((r) => setOrders(r.data)).catch(() => {}), 6000, []);

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Sell Orders</h1>
      {orders.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400">No sell orders yet.</div>
      ) : (
        <div className="space-y-3" data-testid="orders-list">
          {orders.map((o) => (
            <Link to={`/app/orders/${o.order_id}`} key={o.order_id}
              className="bg-white border border-slate-200 rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center gap-3 justify-between hover:shadow-md transition"
              data-testid={`order-row-${o.order_id}`}>
              <div>
                <div className="font-mono text-sm text-slate-900">{o.order_id}</div>
                <div className="text-sm text-slate-600 mt-0.5">{fmtUSDT(o.amount)} USDT @ {fmtINR(o.rate)}</div>
                <div className="text-xs text-slate-400 mt-0.5">{new Date(o.created_at).toLocaleString()}</div>
              </div>
              <div className="flex items-center gap-6">
                <div className="text-right text-sm">
                  <div className="text-slate-500">Expected <span className="font-mono text-slate-900">{fmtINR(o.expected_inr)}</span></div>
                  <div className="text-slate-500">Paid <span className="font-mono text-emerald-700">{fmtINR(o.paid_inr)}</span></div>
                </div>
                <StatusBadge status={o.status} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
